module.exports = __webpack_public_path__ + "static/media/img78.aab73ce9.jpg";